import * as React from "react"

import { concatClassNames } from "helpers/jsxHelpers"
import { Redirect, Route, Switch } from "react-router-dom"

import { NavTabsContentProps } from "../interfaces"

type NavTabsContentListProps = NavTabsContentProps

const NavTabsContentList: React.FC<NavTabsContentListProps> = ({
	tabs,
	className,
}) => {
	const tabContentStyles = concatClassNames(["tab-content", className])

	return (
		<div className={tabContentStyles}>
			<Switch>
				{tabs.map(
					({ active = true, pathname, component }) =>
						active && (
							<Route key={pathname} path={pathname}>
								{component}
							</Route>
						)
				)}
				<Redirect from="/" to={tabs ? tabs[0].pathname : ""} />
			</Switch>
		</div>
	)
}

export default NavTabsContentList
